import { Link, Navigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

const LEGACY = {
  "/index.html": "/",
  "/home.html": "/",
  "/services.html": "/services",
  "/about.html": "/about",
  "/about-us.html": "/about",
  "/contact.html": "/contact",
  "/contact-us.html": "/contact",
  "/blog.html": "/blog",
  "/faqs.html": "/faqs",
  "/faq.html": "/faqs",
  "/privacy.html": "/privacy-policy",
};

export default function NotFound() {
  const { pathname } = useLocation();
  const target = LEGACY[pathname.toLowerCase()];
  if (target) return <Navigate to={target} replace />;

  return (
    <main data-testid="not-found-page" className="grain flex min-h-[80vh] items-center bg-ink pt-24 text-paper">
      <Seo title="Page Not Found | Electra HR" siteName="Electra HR" description="This page doesn't exist, but help with your HR problem does." />
      <div className="container-x py-24">
        <p className="font-mono text-sm text-pink">404</p>
        <h1 className="mt-4 max-w-2xl font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
          This page walked out. Your HR problem doesn't have to.
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-paper/60">
          Whatever you were looking for, the fastest route back is the home page, or straight to us.
        </p>
        <div className="mt-9 flex flex-wrap gap-4">
          <Link to="/" data-testid="notfound-home-link" className="flex items-center gap-2 bg-pink px-6 py-3.5 font-bold text-ink transition-transform duration-300 hover:-translate-y-0.5">
            <ArrowLeft size={17} /> Home
          </Link>
          <Link to="/contact" data-testid="notfound-contact-link" className="border-2 border-white/25 px-6 py-3.5 font-bold text-paper transition-colors hover:border-pink hover:text-pink">
            Contact us
          </Link>
        </div>
      </div>
    </main>
  );
}
